<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Quirofano, type Cirugia } from '../../../lib/api';

  let { limit = 8, onNavigate }: { limit?: number; onNavigate?: (tab: string) => void } = $props();

  let cirugias = $state<Cirugia[]>([]);
  let error = $state<string | null>(null);

  function hoyRango() {
    const d = new Date();
    const desde = new Date(d.getFullYear(), d.getMonth(), d.getDate()).toISOString();
    const hasta = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1).toISOString();
    return { desde, hasta };
  }

  async function cargar() {
    error = null;
    try {
      const { desde, hasta } = hoyRango();
      const all = await Quirofano.agenda(desde, hasta);
      cirugias = all.filter(c => c.estado !== 'CANCELADA').slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  function hora(iso: string) {
    try { return new Date(iso).toLocaleTimeString('es-GT', { hour: '2-digit', minute: '2-digit' }); }
    catch { return iso; }
  }

  function badge(estado?: string) {
    if (estado === 'EN_CURSO') return 'danger';
    if (estado === 'FINALIZADA') return 'ok';
    return '';
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<DashCard title="Agenda quirófano — hoy" hint="{cirugias.length} cirugías">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
    {#if onNavigate}<button type="button" class="btn-sm" onclick={() => onNavigate('quirofano')}>Block</button>{/if}
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if cirugias.length === 0 && !error}
    <p class="empty">Sin cirugías programadas hoy.</p>
  {:else}
    <table class="dash-table">
      <thead><tr><th>Hora</th><th>Procedimiento</th><th>Estado</th></tr></thead>
      <tbody>
        {#each cirugias as c (c.id)}
          <tr>
            <td class="dash-mono">{hora(c.fechaProgramada)}</td>
            <td>{c.procedimiento}</td>
            <td><span class="dash-badge {badge(c.estado)}">{c.estado ?? 'PROGRAMADA'}</span></td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</DashCard>

<style>
  .btn-sm { border: 1px solid var(--glass-border); background: var(--glass-bg-card); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); border-radius: 999px; cursor: pointer; padding: 0.22rem 0.55rem; font-size: 0.72rem; font-weight: 600; transition: all 0.2s; color: var(--text-secondary); }
  .btn-sm:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
</style>
